<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  
						  <el-breadcrumb-item :to="{ path: '/list_wenda'}">问询答复</el-breadcrumb-item>
						  
						  <el-breadcrumb-item>{{detail.comName}} [{{detail.moduleName}}]</el-breadcrumb-item>
						  
						</el-breadcrumb>
					</div>
					
					
					<div class="neirong_line">
						<div class="neirong_line_left">
							
							<div class="neirong_line_region">
								<div class="neirong_line_detail_title">
									{{detail.comName}} [{{detail.moduleName}}]
								</div>
								<div class="neirong_line_detail_content">
									<iframe :src="detail.filePath" width="100%" height="900"></iframe>
									<!-- 这里显示企业的问答拆分后的详情 -->
								</div>
								
								<!-- <div class="neirong_line_split"></div> -->
								
								<div class="neirong_line_option" style="padding-top: 8px;">
									<el-row>
										<!-- <el-col :span="4">
											<el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button>
										</el-col> -->
										<!-- <el-col :span="4" :offset="16">
											<el-link type="primary"> 查看文件 </el-link>
										</el-col> -->
										<!-- <el-col :span="4" :offset="16">
											<el-button icon="el-icon-link" size="mini" style="float: right;"> 获取Word版 </el-button>
										</el-col> -->
										<el-col :span="4" :offset="20">
											<el-button icon="el-icon-download" size="mini" style="float: right;" @click="uDownload(detail.comName, detail.moduleName, detail.filePathTemp)"> 下载文件 </el-button>
										</el-col>
									</el-row>
								</div>
								
							</div>
							
							<!-- <div class="neirong_line_page">
								这里后期可以关联其它跟本文相关的内容或链接
							</div> -->
						</div>

						<div class="neirong_line_right" style="margin-bottom: 15px;">
							<div class="neirong_right_header">
								<div class="myxxx_right_title">我的【{{ kw }}】</div>
							</div>
							<div class="myxxx_right_body" style="height: 380px;">
								<el-row>
									<!-- <el-input
									type="textarea"
									:autosize="{ minRows: 9, maxRows: 9}"
									:placeholder="'在此可以保存和备忘您企业的相关模块信息，用于跟标杆企业对标。\n\n输入信息点击保存试试吧……'"
									v-model="content">
									</el-input> -->
									<div style="border: 1px solid #ccc;">
										<!-- <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor"
											:defaultConfig="toolbarConfig" :mode="mode" /> -->
										<Editor style="height: 340px; overflow-y: hidden;" v-model="content"
											:defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" @customPaste="customPaste" />
									</div>
								</el-row>
								<el-row style="display: flex; justify-content: center; margin-top: 5px">
									<el-button v-if="is_show_myxxx_savebtn == 1" type="primary" style="width: 210px; background-color: #E75122; border-color: #E75122;" @click="updateUserMyxxxContent">保存<label>【{{ kw }}】</label></el-button>
									<el-button v-if="is_show_myxxx_savebtn == 0" type="info" style="width: 210px;" :disabled="true" >暂无保存权限</el-button>
									<el-button v-if="is_show_myxxx_savebtn == 2" type="info" style="width: 210px;" :disabled="true" >升级会员后保存企业画像</el-button>
								</el-row>
							</div>
						</div>
						
						<div class="neirong_line_right">
							<AdverRightCus></AdverRightCus>
						</div>
						
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import AdverRightCus from '../components/adverRight.vue'
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			AdverRightCus,
			Editor,
			Toolbar,
		},
		data() {
			return {
				detail: {
					id: 0,
					com_id: 0,
					module_id: 0,
					file_id: 0,
				},
				kw: '',
				content: '',
				daqu_id: 0,
				mokuai_id: 0,
				cur_user: null,
				temp_user_id: 0,

				editor: null,
				html: '',
				toolbarConfig: {
					excludeKeys: ['insertImage', 'group-video', 'codeBlock', 'divider', 'todo', 'emotion', 'insertLink', 'group-more-style', 'blockquote', 'lineHeight'],
				},
				editorConfig: {
					placeholder: '此处可保存和备忘您企业的相关模块信息，形成您的企业画像，用于跟标杆企业对标。<br/><br/><br/>可复制左侧招股说明书中文字，也可将截图粘贴到此处<br/><br/><br/>快来试试吧',
					MENU_CONF:  {
						"uploadImage": {
							server: 'https://sudomanage.qqbd.vip/pubapi/pub_user_myxxx/editor/upImage',
							fieldName: 'file',
							// 继续写其他配置...
							
							//【注意】不需要修改的不用写，wangEditor 会去 merge 当前其他配置
						}
					},
				},
				mode: 'default', // or 'simple'

				is_show_myxxx_savebtn: -1,

			}
		},
		
		created() {
			this.detail.com_id = this.$route.query.comid
			this.detail.module_id = this.$route.query.moduleid
			this.detail.file_id = this.$route.query.fileid

			if (this.$route.query.daquid == 0) {
				// 如此处理，对应列表页中todetail方法第2个if分支
				this.daqu_id = this.$route.query.moduleid
				this.mokuai_id = 0
			} else {
				this.daqu_id = this.$route.query.daquid
				this.mokuai_id = this.$route.query.moduleid
			}
			console.log('page url parmam daqu_id/mokuai_id', this.daqu_id, this.mokuai_id)
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.loadDetail()

			this.checkViewDetailNum()
		},
		
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		},

		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			// 加载详情
			loadDetail() {
				let cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (cur_user) {
					let url = this.$common.apiUrl + 'pub_company_wenda_split/detail/' + this.detail.com_id + '/' + this.detail.module_id + '/' + this.detail.file_id
					console.log(url)
					this.$axios.get(url).then((res)=>{
						// console.log('分割问询答复文件详情', res.data)
						this.detail = res.data.data
						this.detail.filePath += '&officePreviewType=pdf'

						this.kw = this.detail.moduleName // 我的xxx赋值
						this.loadUserMyxxxContent() // 加载用户我的xxx
					})
				} else {
					// 2025年12月初，高莎莎发信息用户未登录，不显示详情，跳转至登录页
					this.$message.error('用户未登录，无法继续浏览，请登录会员后浏览和下载')
					setTimeout(() => {
						this.toUrl('/login')
					}, 1500)
					return;

					//20240903用户未登录也能加载详情，把if中的逻辑复制过来
					let url = this.$common.apiUrl + 'pub_company_wenda_split/detail/' + this.detail.com_id + '/' + this.detail.module_id + '/' + this.detail.file_id
					console.log(url)
					this.$axios.get(url).then((res)=>{
						// console.log('分割问询答复文件详情', res.data)
						this.detail = res.data.data
						this.detail.filePath += '&officePreviewType=pdf'

						this.kw = this.detail.moduleName // 我的xxx赋值
						this.loadUserMyxxxContent() // 加载用户我的xxx
						this.is_show_myxxx_savebtn = 2
					})
				}
			},
			
			// 用户点击下载
			uDownload(com_name, file_name, file_path) {
				file_name = com_name + ' | ' + file_name
				// console.log('用户下载信息：', file_name, file_path)
				let cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (cur_user) {
					let url = this.$common.apiUrl + 'pub_user_download/add'
					let client_data = this.$qs.stringify({fileName: file_name, filePath: file_path, userId: cur_user.id})
					this.$axios.post(url, client_data).then((res)=>{
						// console.log(res.data)
						if (res.data.msg.indexOf('ERROR') > -1) {
							this.$message.warning(res.data.msg);
						} else {
							//正常下载链接跳转
							window.open(file_path, '_blank')
						}
					})
				} else {
					console.log('用户未登录，无法下载')
				}
			},

			// 加载用户我的xxx数据
			loadUserMyxxxContent() {
				this.cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (this.cur_user) {
					let period_url = this.$common.apiUrl + 'pub_user_period/detail';
					let period_data = this.$qs.stringify({'userId': this.cur_user.id})
					this.$axios.post(period_url, period_data).then((res)=>{
						console.log('user period data is: ', res.data)
						if (res.data.data.parentUserId > 0) {
							// parentUserId大于0，表示有父用户，该账号是个子账号，读写"我的xxx"都用父用户userid
							this.temp_user_id = res.data.data.parentUserId

							// 如果是个子账号，则查询该账号的写入权限
							let purview_url = this.$common.apiUrl + 'pub_user_myxxx_purview/getPurview';
							let purview_data = this.$qs.stringify({ 'userId': this.cur_user.id, 'rType': 1, 'daquId': this.daqu_id, 'mokuaiId': this.mokuai_id })
							this.$axios.post(purview_url, purview_data).then((purview_res) => {
								console.log('user purview_res data is: ', purview_res.data)
								if (purview_res.data.data.isPurviewWrite == 1) {
									this.is_show_myxxx_savebtn = 1
								} else {
									this.is_show_myxxx_savebtn = 0
								}
							})
						} else {
							// parentUserId不大于0，该账号是主账号，读写"我的xxx"用自己的userid
							this.temp_user_id = this.cur_user.id

							this.is_show_myxxx_savebtn = 1
						}

						let url = this.$common.apiUrl + 'pub_user_myxxx_content/getContent'
						let client_data_json = {'userId': this.temp_user_id, 'rType': 2, 'daquId': this.daqu_id, 'mokuaiId': this.mokuai_id}
						let client_data = this.$qs.stringify(client_data_json)
						this.$axios.post(url, client_data).then((res)=>{
							console.log('load cur_user data with userid/daquid/mokuaiid/rtype is: ', res.data, 'client_data is: ', client_data)
							if (res.data.data) {
								this.content = res.data.data.rContent
							} else {
								this.content = ''
							}
						})
					})
				} else {
					console.log('用户未登录，无法加载我的xxx')
				}
				
			},

			// 更新用户我的xxx数据
			updateUserMyxxxContent() {
				// console.log('editor中数据交换给this.content', this.html, this.content)
				this.cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (this.cur_user) {
					let url = this.$common.apiUrl + 'pub_user_myxxx_content/setContent'
					let client_data_json = {'userId': this.temp_user_id, 'rType': 2, 'daquId': this.daqu_id, 'mokuaiId': this.mokuai_id, 
						'rContent': this.content}
					let client_data = this.$qs.stringify(client_data_json)
					this.$axios.post(url, client_data).then((res)=>{
						console.log('update cur_user content data with id and kw, affcted rows is: ',res.data)
						if (res.data.data > 0) {
							// console.log('success...')
							this.$message({
								message: '保存信息成功',
								type: 'success'
							})
							// setTimeout(() => {
							// 	location.reload()
							// }, 700);
						}
					})
				} else {
					console.log('用户未登录，无法更新我的xxx')
				}
			},

			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			customPaste(editor, event, callback) {
				// console.log('ClipboardEvent 粘贴事件对象', event)
				const html = event.clipboardData.getData('text/html') // 获取粘贴的 html
				// console.log('html:', html)
				const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
				// console.log('text', text)
				// const rtf = event.clipboardData.getData('text/rtf') // 获取 rtf 数据（如从 word wsp 复制粘贴）
				// console.log('rtf', rtf)

				if (html.indexOf('meta charset=') > -1 || html.indexOf('<html>') > -1 || html.indexOf('<body>') > -1 || html.indexOf('<span') > -1) {
					// 自定义插入内容
					editor.insertText(text)
					// 返回 false ，阻止默认粘贴行为
					event.preventDefault()
					callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）
				} else {
					// 返回 true ，继续默认的粘贴行为
					callback(true)
				}

				// // 返回 false ，阻止默认粘贴行为
				// event.preventDefault()
				// callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）

				// // 返回 true ，继续默认的粘贴行为
				// callback(true)
			},

			checkViewDetailNum() {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10105').then((res) => {
					// console.log(res.data.data.configJson)
					let viewDetailNum1 = parseInt(eval('(' + res.data.data.configJson + ')')['viewDetailNum1'])
					let viewDetailNum2 = parseInt(eval('(' + res.data.data.configJson + ')')['viewDetailNum2'])
					console.log('load checkViewDetailNum...viewDetailNum1:', viewDetailNum1, 'viewDetailNum2:', viewDetailNum2)

					this.cur_user = JSON.parse(localStorage.getItem('cur_user'));
					if (this.cur_user) {
						console.log('user has login continue...')
						let period_url = this.$common.apiUrl + 'pub_user_period/detail';
						let period_data = this.$qs.stringify({'userId': this.cur_user.id})
						this.$axios.post(period_url, period_data).then((res)=>{
							console.log('user login has period, user period data is: ', res.data)
							if (res.data.data.dictUserType >= 1 && res.data.data.dictUserType <= 100) {
								// 有period数据，但用户类型是2024年8月份之前配置的用户类型，包括3天使用用户，则无效继续坚持
								let cur_view_num2 = parseInt(localStorage.getItem('cur_view_num2'))
								if (cur_view_num2 > 0) {
									console.log('user not pay viewDetailNum2 limit ', viewDetailNum2, 'curviewnum2:', cur_view_num2)
									if (cur_view_num2 >= viewDetailNum2) {
										this.$message.error('用户免费浏览次数已达到最大限制，请开通会员后继续浏览')
										setTimeout(() => {
											this.$router.push({path: '/detail_article?id=3306'})
										}, 2500)
									}
									cur_view_num2 += 1
									localStorage.setItem('cur_view_num2', cur_view_num2)
								} else {
									console.log('user not pay viewDetailNum2 limit ', viewDetailNum2, 'curviewnum2:', cur_view_num2)
									localStorage.setItem('cur_view_num2', 1)
								}
							} else {
								// 有period数据，用户类型是0或大于100，说明是新设置的用户类型
								console.log('user has period, cannot check limit...')
							}
						})
					} else {
						let cur_view_num1 = parseInt(localStorage.getItem('cur_view_num1'))
						if (cur_view_num1 > 0) {
							console.log('user not login viewDetailNum1 limit ', viewDetailNum1, 'cuviewnum1', cur_view_num1)
							if (cur_view_num1 >= viewDetailNum1) {
								this.$message.error('未登录用户浏览次数已达到最大限制，请登陆后继续浏览')
								setTimeout(() => {
									this.$router.push({path: '/login'})
								}, 5000)
							}
							cur_view_num1 += 1
							localStorage.setItem('cur_view_num1', cur_view_num1)
						} else {
							console.log('user not login viewDetailNum1 limit ', viewDetailNum1, 'cuviewnum1', cur_view_num1)
							localStorage.setItem('cur_view_num1', 1)
						}
					}

				})
			},


			
			
		}
	}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.neirong_right_header {
	background-color: #E75122;
	border-top: 15px solid #E75122;
}
.myxxx_right_title {
	color: #E75122
}
</style>